module.exports = __webpack_public_path__ + "img/cross.50a0158e.svg";